// extracted by mini-css-extract-plugin
module.exports = {"client-requirements":"ClientPreferencesView_client-requirements__3BP0N","conflicted":"ClientPreferencesView_conflicted__1KI20"};